import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import EmptyState from '@atlaskit/empty-state';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import UnknownError from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/error/components/empty-search-error-colour/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import { ErrorDisplay } from '../../common/ui/error-display/index.tsx';
import { messages } from './messages.tsx';

const ErrorImage = () => {
	return fg('replace_error_display_with_empty_state') ? (
		<Box xcss={imageWrapperStyles}>
			<UnknownError width={90} height={130} alt="" />
		</Box>
	) : (
		<UnknownError width={90} height={130} alt="" />
	);
};

export const UnknownErrorView = (): React.JSX.Element => {
	const unknownErrorDescriptionIssueTermRefreshGalaxia = expVal(
		'project-terminology-refresh',
		'isEnabled',
		false,
	)
		? messages.unknownErrorDescriptionIssueTermRefreshGalaxia
		: messages.unknownErrorDescriptionIssueTermRefresh;
	const intl = useIntl();

	return (
		<ContextualAnalyticsData
			sourceName="unknownError"
			sourceType={SCREEN}
			attributes={{
				errorType: 'unknown',
				source: globalThis.window?.location?.pathname ?? '',
				referrer: globalThis.document?.referrer ?? '',
				timestamp: new Date().toISOString(),
				userAgent: globalThis.navigator?.userAgent ?? '',
				route: `${globalThis.window?.location?.pathname ?? ''}${globalThis.window?.location?.search ?? ''}`,
			}}
		>
			{fg('replace_error_display_with_empty_state') ? (
				<EmptyState
					testId="issue-view-errors.ui.unknown-error-view.unknown-error-view"
					header={intl.formatMessage(
						expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
							? messages.unknownErrorHeaderIssueTermRefresh
							: messages.unknownErrorHeader,
					)}
					description={intl.formatMessage(
						expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
							? unknownErrorDescriptionIssueTermRefreshGalaxia
							: messages.unknownErrorDescription,
					)}
					renderImage={() => <ErrorImage />}
				/>
			) : (
				<ErrorDisplay
					header={intl.formatMessage(
						expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
							? messages.unknownErrorHeaderIssueTermRefresh
							: messages.unknownErrorHeader,
					)}
					description={intl.formatMessage(
						expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
							? unknownErrorDescriptionIssueTermRefreshGalaxia
							: messages.unknownErrorDescription,
					)}
					image={<ErrorImage />}
				/>
			)}
			<FireScreenAnalytics />
		</ContextualAnalyticsData>
	);
};

const imageWrapperStyles = xcss({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});
